/* Your Legacy — video facade (speed).
   The "Watch them open it" block (and any .st-vid) ships <video preload="none" data-poster> elements
   (data-poster, not poster: a poster attribute is downloaded as soon as the HTML is parsed, ~180 KB
   of thumbnails competing with the main product photo; 21 Oct 2026).
   Even with preload="none", Safari and some Android browsers fetch the video's metadata and first
   bytes for every <video> on the page: four clips = several MB before the visitor scrolls there.
   This script replaces each <video> with a lightweight facade (the poster as a lazy <img> + a
   play button). The real <video> is created only when the visitor taps it, then plays inline.
   Only ONE clip plays at a time: starting another one pauses the previous. */
(function () {
  "use strict";
  var css = ".st-vfac{position:relative;display:block;width:100%;border:0;padding:0;background:#000;cursor:pointer;aspect-ratio:9/16;overflow:hidden;border-radius:inherit}" +
    ".st-vfac img{display:block;width:100%;height:100%;object-fit:cover}" +
    ".st-vfac::after{content:'';position:absolute;left:50%;top:50%;width:56px;height:56px;margin:-28px 0 0 -28px;border-radius:50%;background:rgba(255,255,255,.94) url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M9 6l9 6-9 6z' fill='%232E1200'/%3E%3C/svg%3E\") center/26px no-repeat;box-shadow:0 6px 18px rgba(0,0,0,.3)}" +
    ".st-vid video.st-vlive{display:block;width:100%;height:100%;object-fit:cover;aspect-ratio:9/16;background:#000}";
  var style = document.createElement("style"); style.textContent = css; document.head.appendChild(style);

  var current = null;
  function build(v) {
    var poster = v.getAttribute("data-poster") || v.getAttribute("poster") || "";
    var sources = Array.prototype.map.call(v.querySelectorAll("source"), function (s) { return { src: s.getAttribute("src"), type: s.getAttribute("type") || "" }; });
    if (!sources.length && v.getAttribute("src")) sources.push({ src: v.getAttribute("src"), type: "" });
    if (!sources.length) return;
    var fac = document.createElement("button");
    fac.type = "button"; fac.className = "st-vfac"; fac.setAttribute("aria-label", "Play video");
    if (poster) { var im = document.createElement("img"); im.src = poster; im.alt = ""; im.loading = "lazy"; im.decoding = "async"; fac.appendChild(im); }
    fac.addEventListener("click", function () {
      if (current && current !== fac) { var pv = current.querySelector("video"); if (pv) { try { pv.pause(); } catch (e) {} } }
      var vid = document.createElement("video");
      vid.className = "st-vlive"; vid.controls = true; vid.playsInline = true; vid.setAttribute("playsinline", ""); vid.preload = "auto";
      if (poster) vid.poster = poster;
      sources.forEach(function (s) { var so = document.createElement("source"); so.src = s.src; if (s.type) so.type = s.type; vid.appendChild(so); });
      fac.replaceWith(vid); current = vid.parentNode;
      var p = vid.play(); if (p && p.catch) p.catch(function () {});
      vid.addEventListener("play", function () {
        Array.prototype.forEach.call(document.querySelectorAll("video.st-vlive"), function (o) { if (o !== vid) { try { o.pause(); } catch (e) {} } });
      });
    });
    v.replaceWith(fac);
  }
  function init() { Array.prototype.forEach.call(document.querySelectorAll(".st-vid video"), build); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
